import { buildProps, definePropType } from '@element-plus/utils'
import { numberalPattern } from '@element-plus/hooks'
import type { ExtractPropTypes } from 'vue'
import type Numberal from './numberal.vue'

// ### 数字，保留小数不补0
// 000 数字，保留小数自动补0
// 带 % 百分比，前置%自动 * 100，后置%自动 / 100

export const numberalProps = buildProps({
  /**
   * @description binding number value
   */
  modelValue: {
    type: definePropType<string | number | undefined>([String, Number]),
    default: '',
  },
  /**
   * @description format of number value
   */
  format: {
    type: String,
    default: ',#.##',
    validator: (val: string) => {
      return numberalPattern.test(val)
    },
  },
  /**
   * @description prefix of number value
   */
  prefix: {
    type: String,
    default: '',
  },
  /**
   * @description affix of number value
   */
  affix: {
    type: String,
    default: '',
  },
  /**
   * @description display raw value
   */
  raw: {
    type: Boolean,
    default: true,
  },
  /**
   * @description default text when raw is empty
   */
  defaultText: {
    type: String,
    default: '',
  },
} as const)
export type NumberalProps = ExtractPropTypes<typeof numberalProps>

export type NumberalInstance = InstanceType<typeof Numberal>
